<template>
  <header class="app-header app-header__fixed">
    <div
      class="app-header__logo"
      :class="appModeClass"
      @click.self="turnOffTestOrDemoSign = true"
      :title="appModeTitle"
    >
      <div
        class="app-header__logo-inside"
        @click.self="turnOffTestOrDemoSign = !turnOffTestOrDemoSign"
      >
        <div
          @click="mobileMenu = !mobileMenu"
          class="app-header__menu-trigger"
          v-bind:class="{ 'app-header__menu-trigger__active': !mobileMenu }"
        >
          <span class="app-header__menu-trigger__item"></span>
        </div>
        <router-link :to="{ name: 'home' }">
          <img
            :src="`/img/logo${logoNumber === 1 ? '' : '2'}.${logoNumber === 1 ? 'png' : 'svg'}`"
            alt="logo"
            title="Food Trailers and Trucks .com"
            :class="
              logoNumber === 1
                ? 'app-header__logo-inside-logo-large'
                : 'app-header__logo-inside-logo-small'
            "
          />
          <img
            v-if="logoNumber > 2"
            :src="`/img/icons_c/services${logoNumber - 2}_g.png`"
            alt="logo"
            title="Food Trailers and Trucks .com"
            class="app-header__logo-inside-logo-small app-header__logo-inside-logo-right"
          />
        </router-link>
      </div>
    </div>
    <transition name="slide-top">
      <div
        class="app-header__menu"
        v-if="(mobileMenu && mobileScreen) || !mobileScreen"
        v-bind:class="{ 'app-header__menu-fixed': fixedState }"
      >
        <div class="app-header__menu-inside">
          <div
            v-for="(item, i) in nav"
            v-bind:key="i"
            class="app-header__menu-inside__item"
            :title="item.desc || item.title"
          >
            <router-link
              exact
              :to="{ name: item.link }"
              v-bind:class="{ 'app-header__menu-inside__item-title__active': menu === item.id }"
              class="app-header__menu-inside__item-title"
            >
              {{ item.title }}
              <div
                v-if="item.menu"
                @click.prevent="changeActiveMenu(item.id)"
                class="app-header__menu-inside__item-title__arrow"
              ></div>
            </router-link>
            <ul
              v-if="(!mobileScreen && item.menu) || (mobileScreen && item.menu && menu === item.id)"
              class="app-header__menu-inside__item-list"
            >
              <template v-for="(navItem, j) in item.menu">
                <li
                  v-if="!navItem.submenu"
                  v-bind:key="j"
                  class="app-header__menu-inside__item-list__item"
                >
                  <router-link
                    exact
                    :to="{ name: navItem.link }"
                    class="app-header__menu-inside__item-list__item-link"
                    >{{ navItem.title }}</router-link
                  >
                </li>

                <li
                  v-if="navItem.submenu"
                  v-bind:key="j"
                  class="app-header__menu-inside__item-list__item app-header__menu-inside__item-list__item-sub"
                >
                  <router-link
                    exact
                    :to="{ name: navItem.link }"
                    v-bind:class="{
                      'app-header__menu-inside__item-list__item-sub__link-active':
                        subMenu === navItem.id
                    }"
                    class="app-header__menu-inside__item-list__item-sub__link"
                  >
                    <div
                      @click.prevent="changeActiveSubMenu(navItem.id)"
                      class="app-header__menu-inside__item-list__item-sub__link-arrow"
                    ></div>
                    {{ navItem.title }}
                  </router-link>

                  <ul
                    v-if="!mobileScreen || (mobileScreen && subMenu === navItem.id)"
                    class="app-header__menu-inside__item-list__item-sub__list"
                  >
                    <li
                      v-for="(navSubItem, k) in navItem.submenuList"
                      v-bind:key="k"
                      class="app-header__menu-inside__item-list__item-sub__list-item"
                    >
                      <router-link
                        exact
                        :to="{ name: navSubItem.link }"
                        class="app-header__menu-inside__item-list__item-sub__list-item__link"
                        >{{ navSubItem.title }}</router-link
                      >
                    </li>
                  </ul>
                </li>
              </template>
            </ul>
          </div>
          <v-spacer></v-spacer>
          <ShoppingCart :fixed="false" />
        </div>
      </div>
    </transition>
    <ShoppingCart v-if="!((mobileMenu && mobileScreen) || !mobileScreen)" :fixed="true" />
  </header>
</template>

<script>
import HeaderNav from './helpers/headerNav'
import ShoppingCart from './ShoppingCart'
import Router from '../router'
export default {
  name: 'MainHeader',
  components: {
    ShoppingCart
  },
  data: () => ({
    nav: HeaderNav.NAVIGATION,
    menu: null,
    subMenu: null,
    mobileMenu: false,
    fixedState: false,
    mobileScreen: false,
    logoNumber: 1,
    turnOffTestOrDemoSign: false
  }),
  computed: {
    appModeClass() {
      return process.env.VUE_APP_MODE === 'production' || this.turnOffTestOrDemoSign
        ? ''
        : process.env.VUE_APP_MODE === 'demo'
        ? 'app-header__demo'
        : 'app-header__dev'
    },
    appModeTitle() {
      const suffix = ' (click to hide/show the mode)'

      return process.env.VUE_APP_MODE === 'production'
        ? ''
        : process.env.VUE_APP_MODE === 'demo'
        ? '! DEMO SITE' + suffix
        : process.env.VUE_APP_MODE === 'dev'
        ? '! DEVELOPMENT SITE' + suffix
        : '! LOCAL DEVELOPMENT SITE' + suffix
    }
  },
  created() {
    if (process.env.VUE_APP_MODE !== 'production') {
      Router.beforeEach((to, from, next) => {
        this.turnOffTestOrDemoSign = false
        next()
      })
    }
  },
  mounted() {
    this.initMobileScreen()
    window.addEventListener('resize', this.initMobileScreen)
    window.addEventListener('scroll', this.scrollHandler)
    setInterval(this.switchLogo, 5000)
    this.mainMenuVisible = this.isMainMenuVisible()
  },
  methods: {
    initMobileScreen() {
      this.mobileScreen = document.documentElement.clientWidth < 1200
    },
    scrollHandler() {
      this.fixedState = window.scrollY > 96
    },
    changeActiveMenu(menu) {
      this.menu = this.menu === menu ? null : menu
      this.subMenu = null
    },
    changeActiveSubMenu(subMenu) {
      this.subMenu = this.subMenu === subMenu ? null : subMenu
    },
    switchLogo() {
      this.logoNumber = (this.logoNumber % 5) + 1
    },
    isMainMenuVisible() {
      return (this.mobileMenu && this.mobileScreen) || !this.mobileScreen
    }
  },
  watch: {
    $route() {
      this.mobileMenu = false
    }
  }
}
</script>
<style lang="scss" scoped></style>
